<template>
  <div class="sidebar">
    <div v-if="AuthUser === 'Admin'">
      <div class="newNav" v-if="item === 'dashboard'">
        <span><font-awesome-icon icon="poll" /></span>
        <p>Dashboard</p>
      </div>
      <div class="newNav" v-if="item !== 'dashboard'">
       <routerLink to="/dashboard" active-class="activeLink" class="navItem">
           <font-awesome-icon icon="poll" />
           <p>Dashboard</p>
       </routerLink>
      </div>

      <div class="newNav" v-if="item === 'employee'">
        <span><font-awesome-icon icon="user" /></span>
        <p>Employee</p>
      </div>
      <div class="newNav" v-if="item !== 'employee'">
       <routerLink to="/employee" active-class="activeLink" class="navItem">
        <font-awesome-icon icon="user" />
        <p>Employee</p>
       </routerLink>
      </div>

      <div class="newNav" v-if="item === 'wallet'">
        <span><font-awesome-icon icon="wallet" /></span>
        <p>Wallet</p>
      </div>
      <div class="newNav" v-if="item !== 'wallet'">
       <routerLink to="/wallet" active-class="activeLink" class="navItem">
        <font-awesome-icon icon="wallet" />
        <p>Wallet</p>
       </routerLink>
      </div>



        <div @click="viewPayrollDropDown">
          <span class="dropNav"  v-if="payroll !== 'payroll'">
            <font-awesome-icon icon="money-bill-wave" class="mr"/>
            &nbsp;&nbsp;Payroll
            <font-awesome-icon icon="angle-down" v-show="!payrollDropDown" />
            <font-awesome-icon icon="angle-right" v-show="payrollDropDown" />
          </span>
          <span  class="dropNav" v-if="payroll === 'payroll'">
            <font-awesome-icon icon="money-bill-wave" class="mr"/>&nbsp;&nbsp;Payroll
            <font-awesome-icon icon="angle-down" v-show="!payrollDropDown" />
            <font-awesome-icon icon="angle-right" v-show="payrollDropDown" />
          </span>
          <div class="dropList" v-show="payrollDropDown">
            <div class="newNav">
              <routerLink class="navItem"
                to="/payroll/regular/initiate"
                active-class="activeLink"
                >Run Payroll</routerLink
              >
            </div>
            <div class="newNav">
              <routerLink class="navItem"
                to="/onetime-upload"
                active-class="activeLink"
                >Quick Pay</routerLink
              >
            </div>
            <div>
              <div v-if="item === 'payroll'">Payroll History</div>
              <div v-if="item !== 'payroll'">
                <routerLink to="/payroll" class="navItem" active-class="activeLink"
                  >Payroll History</routerLink
                >
              </div>
            </div>
          </div>
        </div>

        <div @click="viewHrDropDown">
          <span class="dropNav"  v-if="hr !== 'hr'">
            <font-awesome-icon icon="balance-scale" class="mr"/>&nbsp;&nbsp;CoreHR
            <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
            <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
          </span>
          <p class="dropNav" v-if="hr === 'hr'">
            <font-awesome-icon icon="balance-scale" class="mr"/>&nbsp;&nbsp;CoreHR
            <font-awesome-icon icon="angle-down" v-show="!coreHrDropDown" />
            <font-awesome-icon icon="angle-right" v-show="coreHrDropDown" />
          </p>
          <div class="dropList" v-show="coreHrDropDown">
            <!-- <div>
              <div v-if="item === 'query'">Query</div>
              <div v-if="item !== 'query'">
                <routerLink to="/query" active-class="active__link"
                  >Query</routerLink
                >
              </div>
            </div> -->

            <div>
              <p v-if="item === 'promotion'">Promotion</p>
              <span v-if="item !== 'promotion'">
                <routerLink to="/promotion" class="navItem" active-class="activeLink"
                  >Promotion</routerLink
                >
              </span>
            </div>

            <div>
              <p v-if="item === 'leave'">Leave</p>
              <span v-if="item !== 'leave'">
                <routerLink to="/leave-management" class="navItem" active-class="activeLink"
                  >Leave</routerLink
                >
              </span>
            </div>
          </div>
        </div>

        <!-- start -->

         <div class="newNav" v-if="item === 'benefit'">
        <span><font-awesome-icon icon="hand-holding-heart" /></span>
        <p>Benefits</p>
      </div>
      <div class="newNav" v-if="item !== 'benefit'">
       <routerLink to="/benefits" active-class="activeLink" class="navItem">
           <font-awesome-icon icon="hand-holding-heart" />
           <p>Benefits</p>
       </routerLink>
      </div>

      <div class="newNav" v-if="item === 'companydetails'">
        <span><font-awesome-icon icon="id-card" /></span>
        <p>Company Details</p>
      </div>
      <div class="newNav" v-if="item !== 'companydetails'">
       <routerLink to="/company-details" active-class="activeLink" class="navItem">
        <font-awesome-icon icon="id-card" />
        <p>Company Details</p>
       </routerLink>
      </div>
      
      <div class="newNav" v-if="item === 'setting'">
        <span><font-awesome-icon icon="cogs" /></span>
        <p>Settings</p>
      </div>
      <div class="newNav" v-if="item !== 'setting'">
       <routerLink to="/settings" active-class="activeLink" class="navItem">
        <font-awesome-icon icon="cogs" />
        <p>Settings</p>
       </routerLink>
      </div>

        <div class="newNav" v-if="item === 'hire'">
        <span><font-awesome-icon icon="briefcase" /></span>
        <p>Hire</p>
      </div>
      <div class="newNav" v-if="item !== 'hire'">
       <routerLink to="/hire" active-class="activeLink" class="navItem">
        <font-awesome-icon icon="briefcase" />
        <p>Hire</p>
       </routerLink>
      </div>


    
        <!--
          <div class="sidebar__section--nav" v-if="item === 'report'">
            <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
          </div>
          <div class="sidebar__section--nav" v-if="item !== 'report'">
            <routerLink to="/reports" active-class="active__link">
              <font-awesome-icon icon="fax" />&nbsp;&nbsp;Reports
            </routerLink>
          </div>
        -->

        <!-- <div class="sidebar__section--nav" v-if="item === 'contact'">
          <font-awesome-icon icon="calendar-check" />&nbsp;&nbsp;Contact hrdesk
        </div>
        <div class="sidebar__section--nav" v-if="item !== 'contact'">
          <routerLink to="/contact" active-class="active__link">
            <font-awesome-icon icon="calendar-check" />&nbsp;&nbsp;Contact
            hrdesk
          </routerLink>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      coreHrDropDown: false,
      payrollDropDown: false,
      recruitmentDropDown: false,
      AuthUser: null,
    };
  },
  props: ["item", "hr", "payroll", "recruit"],
  methods: {
    viewHrDropDown() {
      if (this.coreHrDropDown) {
        this.coreHrDropDown = false;
      } else {
        this.coreHrDropDown = true;
      }
    },
    viewPayrollDropDown() {
      if (this.payrollDropDown) {
        this.payrollDropDown = false;
      } else {
        this.payrollDropDown = true;
      }
    },

    viewRecruitmentDropDown() {
      if (this.recruitmentDropDown) {
        this.recruitmentDropDown = false;
      } else {
        this.recruitmentDropDown = true;
      }
    },
  },
  created() {
    if (this.$store.getters.currentAuthUser.roles.name) {
      this.AuthUser = this.$store.getters.currentAuthUser.roles.name;
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
.newNav {
  display: flex;
  padding-bottom: 1rem;
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #e57414;
      text-decoration: none;
      cursor: pointer
}
.activeLink {
      color: #000000;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      cursor: pointer
}

.navItem {
  display: flex;
  color: #000000;
}

.dropNav {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.5rem;
  margin-left: 1rem;
  text-decoration: none;
      cursor: pointer
}

.mr {
  margin-right: 0.5rem;
}

.dropList {
  margin-left: 2.5rem;
      color: #000000;
      
  div {
    padding-bottom: 0.5rem;
    text-decoration: none;
      cursor: pointer
  }
}
// .sidebar {
//   padding: 1rem;
//   min-width: 8rem;

//   .section {

//     .nav {
//       padding-bottom: 1.5rem;
//       font-size: 1rem;
//       font-weight: normal;
//       font-style: normal;
//       font-stretch: normal;
//       line-height: 1.22;
//       letter-spacing: normal;
//       text-align: left;
//       color: #e57414;
//       // border: 2px solid red;
//       min-width: 20rem;
//       display: flex;

//       > span {
//         color: #000000;
//         cursor: pointer;
        

//         &:hover {
//           color: #e57414;
//         }
//       }

//       > p {
//         color: #e57414;
//         cursor: pointer;
//         margin: 0;
//       }

//       .nav-item {
//         padding-left: 15px;

//         > div {
//           padding-top: 20px;
//           color: #000;

//           > span {
//             color: #e57414;
//           }
//         }
//       }

//       a {
//         color: #000;
//         text-decoration: none;
//         &:hover {
//           color: #e57414;
//         }
//       }
//     }
//   }

//   .active__link {
//     color: #e57414 !important;
//   }
// }
</style>
